module.exports = __webpack_public_path__ + "img/infoq.2307e257.png";